export default "__VITE_ASSET__BTXlt76h__"